/* PELLINGTON - Shop Now filter bar. 5 Oct 2026.
   Used by sections/pell-collection-filters.liquid, which also holds the
   category / style / stone / price list (#pf-config) and the full notes.
   Filters the cards that sections/main-collection tags with data-pf-*. */
(function () {
  var root = document.getElementById('pf');
  var cfgEl = document.getElementById('pf-config');
  if (!root || !cfgEl) return;
  var C = JSON.parse(cfgEl.textContent);
  var T = C.t;

  function q(s, el) { return (el || root).querySelector(s); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function piecesText(n) { return C.ar ? 'عدد القطع: ' + n : n + (n === 1 ? ' piece' : ' pieces'); }
  function showText(n) { return C.ar ? 'عرض النتائج (' + n + ')' : 'Show ' + n + (n === 1 ? ' piece' : ' pieces'); }
  function track(name) { try { if (window.clarity) { window.clarity('event', name); window.clarity('set', 'shop_filters', 'used'); } } catch (e) {} }

  var catByKey = {}, catByType = {};
  C.cats.forEach(function (c) { catByKey[c.key] = c; catByType[c.type] = c; });
  var stoneKeys = C.stones.map(function (s) { return s.key; });
  var priceKeys = C.prices.map(function (p) { return p.key; });

  var state = { cat: 'all', style: '', stones: [], prices: [], open: null };
  var items = [];
  var lockedCat = null; // set when the collection holds one category only (Rings page etc.)
  var grid, empty, ov, panel, opener = null;

  function band(price) {
    for (var i = 0; i < C.prices.length; i++) { if (price >= C.prices[i].min && price <= C.prices[i].max) return C.prices[i].key; }
    return '';
  }
  function pass(it, skip) {
    if (skip !== 'cat' && state.cat !== 'all' && it.cat !== state.cat) return false;
    if (skip !== 'cat' && skip !== 'style' && state.style && it.style !== state.style) return false;
    if (skip !== 'stone' && state.stones.length && state.stones.indexOf(it.stone) < 0) return false;
    if (skip !== 'price' && state.prices.length && state.prices.indexOf(it.band) < 0) return false;
    return true;
  }
  function count(fn) { var n = 0; for (var i = 0; i < items.length; i++) if (fn(items[i])) n++; return n; }
  // styles of a category that this collection actually holds (Tennis page: only Tennis)
  function stylesIn(catKey) {
    if (catKey === 'all') return [];
    return catByKey[catKey].styles.filter(function (s) { return count(function (it) { return it.cat === catKey && it.style === s.key; }) > 0; });
  }

  function readURL() {
    var p = new URLSearchParams(location.search);
    var cat = p.get('cat'); if (!lockedCat && cat && catByKey[cat]) state.cat = cat;
    var st = p.get('style');
    if (st && stylesIn(state.cat).some(function (s) { return s.key === st; })) state.style = st;
    state.stones = (p.get('stone') || '').split(',').filter(function (k) { return stoneKeys.indexOf(k) > -1; });
    state.prices = (p.get('price') || '').split(',').filter(function (k) { return priceKeys.indexOf(k) > -1; });
  }
  function writeURL() {
    var p = new URLSearchParams(location.search);
    ['cat', 'style', 'stone', 'price', 'page'].forEach(function (k) { p.delete(k); });
    if (state.cat !== 'all' && !lockedCat) p.set('cat', state.cat);
    if (state.style) p.set('style', state.style);
    if (state.stones.length) p.set('stone', state.stones.join(','));
    if (state.prices.length) p.set('price', state.prices.join(','));
    var s = p.toString();
    try { history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash); } catch (e) {}
  }

  function tiles(kind) {
    var list = kind === 'stone' ? C.stones : C.prices;
    var chosen = kind === 'stone' ? state.stones : state.prices;
    return '<div class="pf-tiles' + (kind === 'price' ? ' p3' : '') + '">' + list.map(function (o) {
      var n = count(function (it) { return pass(it, kind) && (kind === 'stone' ? it.stone === o.key : it.band === o.key); });
      var on = chosen.indexOf(o.key) > -1;
      return '<button type="button" class="pf-tile' + (n || on ? '' : ' pf-off') + '" data-' + kind + '="' + o.key + '" aria-pressed="' + on + '"' + (n || on ? '' : ' disabled') + '>' +
        (kind === 'stone' ? '<i style="background:' + o.sw + '" aria-hidden="true"></i>' : '') + esc(o.label) + '<em>' + n + '</em></button>';
    }).join('') + '</div>';
  }

  function render() {
    var shown = 0;
    items.forEach(function (it) { var ok = pass(it); it.li.style.display = ok ? '' : 'none'; if (ok) shown++; });
    empty.hidden = shown > 0;

    if (!lockedCat) q('.pf-cats').innerHTML = [{ key: 'all', label: T.all }].concat(C.cats).map(function (c) {
      var n = count(function (it) { return (c.key === 'all' || it.cat === c.key) && pass(it, 'cat'); });
      if (c.key !== 'all' && !count(function (it) { return it.cat === c.key; })) return '';
      return '<button type="button" data-cat="' + c.key + '" aria-pressed="' + (state.cat === c.key) + '"' + (n || state.cat === c.key ? '' : ' class="pf-off"') + '>' + esc(c.label) + '<sup>' + n + '</sup></button>';
    }).join('');

    var stylesEl = q('.pf-styles');
    var styles = stylesIn(state.cat);
    if (styles.length > 1) {
      stylesEl.innerHTML = [{ key: '', label: T.all }].concat(styles).map(function (s) {
        var n = count(function (it) { return it.cat === state.cat && (!s.key || it.style === s.key) && pass(it, 'style'); });
        return '<button type="button" data-style="' + s.key + '" aria-pressed="' + (state.style === s.key) + '"' + (n || state.style === s.key ? '' : ' class="pf-off"') + '>' + esc(s.label) + '<sup>' + n + '</sup></button>';
      }).join('');
      stylesEl.hidden = false;
    } else { stylesEl.innerHTML = ''; stylesEl.hidden = true; }

    var nf = state.stones.length + state.prices.length;
    var badge = q('.pf-badge'); badge.textContent = nf; badge.classList.toggle('is-on', nf > 0);
    var bs = q('[data-open=stone]'), bp = q('[data-open=price]');
    bs.classList.toggle('has', state.stones.length > 0); bp.classList.toggle('has', state.prices.length > 0);
    bs.classList.toggle('is-open', state.open === 'stone'); bp.classList.toggle('is-open', state.open === 'price');
    bs.setAttribute('aria-expanded', state.open === 'stone'); bp.setAttribute('aria-expanded', state.open === 'price');
    q('.pf-open').setAttribute('aria-expanded', state.open === 'all');
    q('.pf-count').textContent = piecesText(shown);

    var tags = state.stones.map(function (k) { var o = C.stones[stoneKeys.indexOf(k)]; return '<button type="button" class="pf-tag" data-rm-stone="' + k + '" aria-label="' + esc(T.remove + ' ' + o.label) + '">' + esc(o.label) + '<span aria-hidden="true">×</span></button>'; })
      .concat(state.prices.map(function (k) { var o = C.prices[priceKeys.indexOf(k)]; return '<button type="button" class="pf-tag" data-rm-price="' + k + '" aria-label="' + esc(T.remove + ' ' + o.tag) + '">' + esc(o.tag) + '<span aria-hidden="true">×</span></button>'; }));
    q('.pf-active').innerHTML = tags.length ? tags.join('') + '<button type="button" class="pf-clear" data-clear="1">' + esc(T.clear) + '</button>' : '';

    if (state.open) {
      var secs = state.open === 'all' ? ['stone', 'price'] : [state.open];
      panel.innerHTML = '<div class="pf-ph"><h3>' + esc(T.filter) + '</h3><button type="button" class="pf-x" data-close="1" aria-label="' + esc(T.close) + '">×</button></div>' +
        secs.map(function (k) { return '<div class="pf-sec"><h4>' + esc(k === 'stone' ? T.stone : T.price) + '</h4>' + tiles(k) + '</div>'; }).join('') +
        '<div class="pf-pf"><button type="button" class="pf-clear" data-clear="1">' + esc(T.clear) + '</button><button type="button" class="pf-show" data-close="1">' + esc(showText(shown)) + '</button></div>';
      if (window.matchMedia('(min-width: 990px)').matches && state.open !== 'all') {
        var b = q('[data-open=' + state.open + ']'), bar = q('.pf-bar');
        var off = C.ar ? bar.getBoundingClientRect().right - b.getBoundingClientRect().right : b.getBoundingClientRect().left - bar.getBoundingClientRect().left;
        panel.style.insetInlineStart = off + 'px';
      } else { panel.style.insetInlineStart = ''; }
      panel.hidden = false;
    } else { panel.hidden = true; panel.innerHTML = ''; }
    ov.classList.toggle('is-on', !!state.open);
    document.documentElement.classList.toggle('pf-lock', state.open === 'all' && !window.matchMedia('(min-width: 990px)').matches);
  }

  function setOpen(v, from) {
    var was = state.open;
    state.open = v;
    if (v) opener = from || opener;
    render();
    if (v && !was) { var f = panel.querySelector('.pf-tile:not([disabled]), .pf-x'); if (f) f.focus({ preventScroll: true }); }
    if (!v && was && opener) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
  }
  // keep the chosen category tab in view on a phone, sideways only
  function revealTab() {
    var row = q('.pf-cats'), act = row.querySelector('[aria-pressed="true"]');
    if (!act || row.scrollWidth <= row.clientWidth) return;
    var r = act.getBoundingClientRect(), rr = row.getBoundingClientRect();
    if (r.left < rr.left + 8 || r.right > rr.right - 36) row.scrollBy({ left: (r.left + r.width / 2) - (rr.left + rr.width / 2), behavior: 'smooth' });
  }
  function toggle(list, k) { var i = list.indexOf(k); if (i > -1) list.splice(i, 1); else list.push(k); }

  function onClick(e) {
    var b = e.target.closest('button'); if (!b || !root.contains(b)) return;
    var d = b.dataset, changed = true;
    if (d.cat !== undefined) { state.cat = d.cat; state.style = ''; track('filter_category'); }
    else if (d.style !== undefined) { state.style = d.style; track('filter_style'); }
    else if (d.open) { setOpen(state.open === d.open ? null : d.open, b); return; }
    else if (d.stone) { toggle(state.stones, d.stone); track('filter_stone'); }
    else if (d.price) { toggle(state.prices, d.price); track('filter_price'); }
    else if (d.rmStone) { toggle(state.stones, d.rmStone); }
    else if (d.rmPrice) { toggle(state.prices, d.rmPrice); }
    else if (d.clear) { state.stones = []; state.prices = []; }
    else if (d.close) { setOpen(null); return; }
    else changed = false;
    if (!changed) return;
    e.preventDefault();
    writeURL();
    render();
    if (d.cat !== undefined) revealTab();
  }

  function init() {
    grid = document.getElementById('ProductGrid');
    if (!grid) { document.documentElement.classList.remove('pf-pending'); return; }
    items = Array.prototype.map.call(grid.querySelectorAll(':scope > li[data-pf-type]'), function (li) {
      var c = catByType[li.getAttribute('data-pf-type')];
      var price = parseFloat(li.getAttribute('data-pf-price')) || 0;
      return { li: li, cat: c ? c.key : '', style: li.getAttribute('data-pf-style') || '', stone: li.getAttribute('data-pf-stone') || '', price: price, band: band(price) };
    });
    empty = document.createElement('div');
    empty.className = 'pf-empty'; empty.hidden = true;
    empty.innerHTML = esc(T.empty) + '<button type="button">' + esc(T.emptyBtn) + '</button>';
    grid.parentNode.insertBefore(empty, grid.nextSibling);
    empty.querySelector('button').addEventListener('click', function () { state.cat = lockedCat || 'all'; state.style = ''; state.stones = []; state.prices = []; writeURL(); render(); });

    ov = document.createElement('div'); ov.className = 'pf-ov'; document.body.appendChild(ov);
    ov.addEventListener('click', function () { setOpen(null); });
    panel = q('.pf-panel');

    root.addEventListener('click', onClick);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open) setOpen(null); });
    window.addEventListener('resize', function () { if (state.open) render(); });

    var sel = document.getElementById('pf-sort-select');
    if (sel) sel.addEventListener('change', function () {
      var p = new URLSearchParams(location.search);
      p.set('sort_by', sel.value); p.delete('page');
      location.assign(location.pathname + '?' + p.toString());
    });

    var present = C.cats.filter(function (c) { return count(function (it) { return it.cat === c.key; }) > 0; });
    if (present.length === 1) {
      lockedCat = present[0].key; state.cat = lockedCat;
      q('.pf-catwrap').hidden = true; root.classList.add('pf--single');
    }

    readURL();
    render();
    revealTab();
    document.documentElement.classList.remove('pf-pending');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();